import moment from 'moment';
import Card from '../../../components/Card';
import { formatAmountWithSuffix } from '../../../helpers';
import { TxLinkIcon } from '../../../assets/icons';
import ExternalLink from '../../../components/ExternalLink';
import { PayoutActivity } from '../../../hooks/referral/useUserReferralStats';
import { useWeb3React } from '@web3-react/core';
import { CHAIN_INFO, SupportedChains } from '../../../config/constants';

type PayoutActivityRowProps = {
    payout: PayoutActivity;
    style?: React.CSSProperties;
};

const PayoutActivityRow: React.FC<PayoutActivityRowProps> = ({ payout, style }) => {
    const { chainId } = useWeb3React();
    const { timestamp, earnings, tradeSize, txHash } = payout;

    return (
        <Card className='payout-activity__row row' style={style}>
            <div className='payout-acitvity__earnings'>
                <span className='column-label'>Your Earnings</span>
                {formatAmountWithSuffix(earnings, {
                    minDecimals: 2,
                    currency: 'USD',
                    minValue: 1_000_000_000,
                })}
            </div>
            <div className='payout-acitvity__trade-size'>
                <span className='column-label'>Trade Size</span>
                {formatAmountWithSuffix(tradeSize, {
                    minDecimals: 2,
                    currency: 'USD',
                    minValue: 1_000_000_000,
                })}
            </div>
            <div className='payout-acitvity__date'>
                <span className='column-label'>Date</span>
                {moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss')}
            </div>
            <div className='payout-acitvity__txHash'>
                <span className='column-label'>TX ID</span>
                <ExternalLink
                    to={`${
                        CHAIN_INFO[chainId as SupportedChains]?.blockExplorer
                    }/tx/${txHash}`}
                >
                    <span>{txHash}</span> <TxLinkIcon />
                </ExternalLink>
            </div>
        </Card>
    );
};

export default PayoutActivityRow;
